module.exports = __webpack_public_path__ + "img/car.f99494e6.svg";